/**
 * B5(0925 收尾波):蒙版局部重绘只有万相实现,选中 OPENAI 家族(普通档/VIP/2.5 Flare/
 * Sunburst)又涂了 mask 提交会直接失败(0923 只改了报错文案,这次是前置拦)。
 *
 * 判据认 `provider` 的值本身变化,不逐个拦 `setProvider` 的调用点 —— 无论是用户在
 * ⚙参数弹窗手选、草稿恢复、还是 capabilities 到货后 `useFreeCreateConstraints` 的
 * 自动纠偏 cascade,只要切成了 OPENAI 家族且当时已经涂过 mask,就真的清空画布
 * (`painterRef.current.reset()`,不止清 `maskPainted` 布尔值)并 toast 说明。
 *
 * MaskPainter 组件本身另按 `isOpenAiFamilyProvider(provider)` 传 `disabledReason`
 * 禁用入口(FreeCreateBody 渲染处)—— 两者合起来保证「OPENAI 选中 ⇒ 不会有涂过的
 * mask 被提交」:这个 hook 兜住"切换前就涂过"的存量,入口禁用兜住"切换后想再涂"。
 */
import { useEffect, useRef } from "react";
import type { RefObject } from "react";

import { toast } from "@/shared/hooks/use-toast";
import type { Provider } from "../../api/posterService";
import type { MaskPainterHandle } from "../../ui/components/free-create/MaskPainter";
import { isOpenAiFamilyProvider, posterProviderLabel } from "../providerLabels";

interface Args {
  provider: Provider;
  maskPainted: boolean;
  setMaskPainted: (v: boolean) => void;
  painterRef: RefObject<MaskPainterHandle | null>;
}

export function useMaskClearOnProviderSwitch({
  provider,
  maskPainted,
  setMaskPainted,
  painterRef,
}: Args): void {
  const prevProviderRef = useRef(provider);
  useEffect(() => {
    const prev = prevProviderRef.current;
    prevProviderRef.current = provider;
    if (prev === provider) return; // 没换 provider,不是这个闸管的事
    if (!isOpenAiFamilyProvider(provider) || !maskPainted) return;
    painterRef.current?.reset();
    setMaskPainted(false);
    toast({
      title: "已清空局部重绘的涂抹",
      description: `「${posterProviderLabel(provider)}」档暂不支持局部重绘,已按整图重绘处理;想用局部重绘请切回「精绘」档。`,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [provider, maskPainted]);
}
